// BTW SWITCH
class VatSwitch extends HTMLElement {
  constructor() {
    super();

    this.dataPriceIncl;
    this.dataPriceExcl;
    this.switchInput;

    subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
      this.refreshPrices();
    });
  }

  // When custom element loads on page
  connectedCallback() {
    this.switchInput = this.querySelector('#btw-switch-toggle') ? this.querySelector('#btw-switch-toggle') : document.querySelector('#btw-switch-toggle');
    this.dataPriceExcl = document.querySelectorAll('[data-price-excl]');
    this.dataPriceIncl = document.querySelectorAll('[data-price-incl]');

    this.listenForEvents();
    this.initVAT();
  }

  /* EVENT LISTENERS */
  listenForEvents() {
    // If toggle input changes
    this.switchInput.addEventListener('change', () => this.updateVAT());
  }

  /* FUNCTIONS */
  initVAT() {
    // Checking if vatToggle sessionStorage is set - if not setting the vatToggle sessionStorage
    if (!sessionStorage.getItem('vatToggle')) {
      this.updateVAT();
      return;
    } 

    // Checking the VAT value (true or false)
    this.checkVat(sessionStorage.getItem('vatToggle'));
  }

  updateVAT() {
    // Setting vatToggle session storage
    if (this.switchInput.checked) {
      sessionStorage.setItem('vatToggle', true);
    } else {
      sessionStorage.setItem('vatToggle', false);
    }

    // Checking the VAT value (true or false)
    this.checkVat(sessionStorage.getItem('vatToggle'));  
  }

  checkVat(value) {
    // Check if VAT is true or false
    const isIncl = value === 'true';

    if (isIncl) {
      this.switchInput.checked = isIncl;
    } else {
      this.switchInput.checked = false;
    }

    this.togglePrices(value);
  }

  togglePrices(value) {
    // Toggling prices
    const isIncl = value === 'true';
    const prices = isIncl ? this.dataPriceIncl : this.dataPriceExcl;
    const key = isIncl ? 'priceIncl' : 'priceExcl';

    prices.forEach(price => {
      if (price.dataset[key]) {
        price.innerHTML = price.dataset[key];
      }
    })
  }

  refreshPrices() {
    // opnieuw alle prijs-elementen pakken
    this.dataPriceExcl = document.querySelectorAll('[data-price-excl]');
    this.dataPriceIncl = document.querySelectorAll('[data-price-incl]');

    // sessionStorage waarde opnieuw toepassen
    this.checkVat(sessionStorage.getItem('vatToggle'));
  }
} 

customElements.define('vat-switch', VatSwitch)




